import {computed, defineComponent, type PropType} from 'vue';
import {type IBasketItem} from "@/app/stores/session-store.ts";
import {useFormatting} from "@/composables/currency-format.ts";
import {useProductStore} from "@/app/stores/product-store.ts";
import {AthumiService} from "@/api/enterprise-gateway-api.proxy.ts";
import {Button, Column, DataTable} from 'primevue';

export default defineComponent({
    name: 'AegServiceProducts',
    components: {Button, DataTable, Column },
    props: {
        selectedService: {
            type: String as PropType<AthumiService>,
            required: true
        },
        paymentType: {
            type: String,
            required: true
        }
    },
    emits: ['on-add'],
    setup(props,  {emit}) {
        const productStore = useProductStore();
        const selectedServiceInfo = computed(() => productStore.serviceInfoMap[props.selectedService]);
        const {formatCurrency} = useFormatting();

        const filteredItems = computed(() => {
            const items = selectedServiceInfo.value?.items ?? [];
            return props.paymentType === 'selfBilling'
                ? items.filter(item => item.isSelfBilling)
                : items;
        });

        const isVip = computed(() => props.selectedService === AthumiService.Vip);

        const addItemToBasket = (item: IBasketItem) => {
            const itemWithoutExtraInfo = {...item};
            itemWithoutExtraInfo.extraInfo = '';
            emit('on-add', {item: itemWithoutExtraInfo, isDiscount: false});
        }

        const addItemToBasketAsDiscount = (item: IBasketItem) => {
            emit('on-add', {item, isDiscount: true});
        }

        return {
            selectedServiceInfo,
            isVip,
            filteredItems,
            addItemToBasket,
            addItemToBasketAsDiscount,
            formatCurrency
        }
    }
})
